<template>
  <div class="flex flex-col space-y-4">
    <div class="flex justify-between items-center">
      <div class="tabs flex space-x-8 border-b mb-6">
        <button
          @click="currentTab = 'TriageReports'"
          class="px-6 py-3 font-semibold text-lg border-b-4 transition-all duration-200"
          :class="{
            'border-custom-yellow text-custom-blue': currentTab === 'TriageReports',
            'text-gray-500 hover:text-gray-700': currentTab !== 'TriageReports'
          }"
        >
          Triage Reports
        </button>
        <button
          @click="currentTab = 'ConsultationReports'"
          class="px-6 py-3 font-semibold text-lg border-b-4 transition-all duration-200"
          :class="{
            'border-custom-yellow text-custom-blue': currentTab === 'ConsultationReports',
            'text-gray-500 hover:text-gray-700': currentTab !== 'ConsultationReports'
          }"
        >
          Consultation Reports
        </button>
        <button
          @click="currentTab = 'LaboratoryReports'"
          class="px-6 py-3 font-semibold text-lg border-b-4 transition-all duration-200"
          :class="{
            'border-custom-yellow text-custom-blue': currentTab === 'LaboratoryReports',
            'text-gray-500 hover:text-gray-700': currentTab !== 'LaboratoryReports'
          }"
        >
          Laboratory Reports
        </button>
        <button
          @click="currentTab = 'RadiologyReports'"
          class="px-6 py-3 font-semibold text-lg border-b-4 transition-all duration-200"
          :class="{
            'border-custom-yellow text-custom-blue': currentTab === 'RadiologyReports',
            'text-gray-500 hover:text-gray-700': currentTab !== 'RadiologyReports'
          }"
        >
          Radiology Reports
        </button>
        <!-- Add more tabs later: Revenue, etc. -->
        <button
          @click="currentTab = 'PharmacyReports'"
          class="px-6 py-3 font-semibold text-lg border-b-4 transition-all duration-200"
          :class="{
            'border-custom-yellow text-custom-blue': currentTab === 'PharmacyReports',
            'text-gray-500 hover:text-gray-700': currentTab !== 'PharmacyReports'
          }"
        >
          Pharmacy Reports
        </button>

        <button
          @click="currentTab = 'BillReports'"
          class="px-6 py-3 font-semibold text-lg border-b-4 transition-all duration-200"
          :class="{
            'border-custom-yellow text-custom-blue': currentTab === 'BillReports',
            'text-gray-500 hover:text-gray-700': currentTab !== 'BillReports'
          }"
        >
          Bill Reports
        </button>
      </div>
    </div>

    <TriageReportsList v-if="currentTab === 'TriageReports'" />
    <ConsultationReportsList v-if="currentTab === 'ConsultationReports'"/>

    <!-- Tab Contents -->
    <LaboratoryReportsList
      v-if="currentTab === 'LaboratoryReports'"
      :key="refreshKey"
    />
    <RadiologyReportsList v-if="currentTab === 'RadiologyReports'" />
    <PharmacyReportsList v-if="currentTab === 'PharmacyReports'" />
    <BillReportsList v-if="currentTab === 'BillReports'" />

  </div>
</template>

<script setup>
import { ref } from 'vue'
import TriageReportsList from '@/views/pages/statistical_reports/TriageReportsList.vue'
import ConsultationReportsList from '@/views/pages/statistical_reports/ConsultationReportsList.vue'
import LaboratoryReportsList from '@/views/pages/statistical_reports/LaboratoryReportsList.vue'
import RadiologyReportsList from '@/views/pages/statistical_reports/RadiologyReportsList.vue'
import PharmacyReportsList from '@/views/pages/statistical_reports/PharmacyReportsList.vue'
import BillReportsList from '@/views/pages/statistical_reports/BillReportsList.vue'

const currentTab = ref('TriageReports')
const refreshKey = ref(0)

// Optional: force refresh all tabs
// const refetch = () => {
//   refreshKey.value += 1
// }
</script>
